import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiClient } from '../../services/apiClient';

const ORGANIZATION_AGENTS_PATH = '/app/organization?tab=agents';
let inFlightExchangeKey = null;
let inFlightExchangePromise = null;

export default function GoogleOAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const oauthError = searchParams.get('error');
  const oauthErrorDescription = searchParams.get('error_description');
  const redirectUri = `${window.location.origin}/oauth/google/callback`;

  useEffect(() => {
    if (oauthError) {
      setErrorMessage(oauthErrorDescription || oauthError);
      return;
    }

    if (!code || !state) {
      setErrorMessage('missing_code_or_state');
      return;
    }

    const exchangeKey = `${code}:${state}`;
    if (inFlightExchangeKey !== exchangeKey || !inFlightExchangePromise) {
      inFlightExchangeKey = exchangeKey;
      inFlightExchangePromise = apiClient
        .exchangeGoogleToken({ code, state, redirectUri })
        .finally(() => {
          if (inFlightExchangeKey === exchangeKey) {
            inFlightExchangeKey = null;
            inFlightExchangePromise = null;
          }
        });
    }

    let isActive = true;
    (async () => {
      try {
        await inFlightExchangePromise;
        window.location.replace(ORGANIZATION_AGENTS_PATH);
      } catch (e) {
        if (isActive) {
          setErrorMessage(e.message || 'exchange_failed');
        }
      }
    })();

    return () => {
      isActive = false;
    };
  }, [
    code,
    state,
    oauthError,
    oauthErrorDescription,
    redirectUri
  ]);

  if (errorMessage) {
    return (
      <div className="loading-container">
        <p>Google connection failed.</p>
        <p>{errorMessage}</p>
        <button type="button" onClick={() => navigate(ORGANIZATION_AGENTS_PATH)}>
          Back to organization
        </button>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <p>Connecting Google</p>
    </div>
  );
}
